/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';
import Time from 'solis/time';

import Text from 'solis/react/primitive/text';

import BoardCass from 'solis/logic/board/cass';
import BoardRanges from 'solis/logic/board/ranges';

import TimeBadge from 'solis/claude/element/time.badge';
import PeakRow from 'solis/claude/element/peak/row';
import Attack from 'solis/claude/button/attack';

import Strength from 'solis/claude/card/attack/strength';


const formatMultiplier = (count) =>
{
  return '×' + Number(count.toFixed(1));
};


const formatPlayers = (count) =>
{
  return count + (count === 1 ? ' player' : ' players');
};


const Component = ({ board, colony, account, galaxy, now }) =>
(
  <Card>
    <Flex direction = 'column' gap = '3'>

      <Flex justify = 'between' align = 'center'>
        <Text.Label>{board.cass.name}</Text.Label>
        <TimeBadge date = {board.cass.destroyDate} />
      </Flex>

      <Flex justify = 'between' align = 'center'>
        <Text.Note>{'Authority '}<Text size = '1' weight = 'bold'>{formatMultiplier(new BoardCass(board).getRemainingScoreCount(now))}</Text></Text.Note>
        <PeakRow board = {board} />
      </Flex>

      <Flex justify = 'between' align = 'center'>
        <Flex direction = 'column'>
          <Text size = '2' color = 'gray'>{formatPlayers(new BoardRanges(board).getUsersByAttachDate().length)}</Text>
          <Text.Note>strength vs you</Text.Note>
        </Flex>
        <Strength board = {board} account = {account} galaxy = {galaxy} />
      </Flex>

      <Attack board = {board} colony = {colony} />

    </Flex>
  </Card>
);


export default ({ board, colony }) =>
{
  const galaxy = use(Galaxy);
  const now = use(Time);

  if (board == null)
  {
    return null;
  }

  return <Component board = {board} colony = {colony} account = {galaxy.getCurrentAccount()} galaxy = {galaxy} now = {now} />;
};
